import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Cheveux = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.56 102.48">
  <G fill={color}>
    <Path d="M60.12,87.73c.71,1.13,2.83,2.75,9.03,3.59-5.6-9.94-5.04-22.69-4.23-29.26,1.05-2.99,1.79-6.25,2.12-9.79l.12.14s6.68-27.75-4.15-41.02C52.18-1.88,22.23-4.51,16.24,8.62,6.86,10.91-4.54,15.93,2.7,51.57c.26,3.37.88,6.51,1.79,9.4.86,6.16,1.84,19.84-4.09,30.36,6.21-.84,8.32-2.47,9.03-3.59-1.55,5.16-4.03,10.15-9.43,14.75,4.8-.33,10.24-1.91,16.24-6.95,5.01-4.21,6.57-10.22,6.95-12.1,4.15,2.16,8.26,3.25,11.61,3.25s7.44-1.07,11.58-3.2c.4,1.94,1.99,7.87,6.94,12.04,5.99,5.04,11.43,6.63,16.24,6.95-5.4-4.59-7.89-9.59-9.43-14.75ZM59.7,47.98c0,21.89-17.81,31.16-24.9,31.16s-24.7-9.27-24.7-31.16v-12.63c1.88-.85,8.27-4.24,11.2-12.44.23-.65,10.14,19.36,24.43,13.83-4.15-6.42-3.46-11.06-3.46-11.06,0,0,5.82,8.91,17.43,9.63v12.67Z"/>
    <Path d="M21.45,41.1c-2.08,0-3.77,1.69-3.77,3.77v5.42c0,2.08,1.69,3.77,3.77,3.77s3.77-1.69,3.77-3.77v-5.42c0-2.08-1.69-3.77-3.77-3.77Z"/>
    <Path d="M44.63,50.3c0,2.08,1.69,3.77,3.77,3.77s3.77-1.69,3.77-3.77v-5.42c0-2.08-1.69-3.77-3.77-3.77s-3.77,1.69-3.77,3.77v5.42Z"/>
    <Path d="M38.13,62.46c-2.43,1.98-4.24,1.98-6.67,0-1.62-1.32-3.99-1.07-5.31.54-1.32,1.62-1.07,3.99.54,5.31,2.61,2.13,5.36,3.19,8.1,3.19s5.49-1.06,8.1-3.19c1.62-1.32,1.86-3.69.54-5.31-1.32-1.62-3.69-1.86-5.31-.54Z"/>
  </G>
</Svg>
);
};

export default Cheveux;
